import { BaseError } from './BaseError'

export const getResponseError = (error) => {
    if (error.message) {
        return error.message
    } else if (error.request) {
        return 'We appear to be having server issues'
    } else {
        return 'Something went wrong'
    }
}

export const handleFetchErrors = async (response) => {
    if (!response.ok) {
        let res = await response.json()
        throw new Error(
            res.detail && typeof res.detail === 'string'
                ? res.detail
                : 'Something went wrong',
        )
    }
    return response.json()
}

export const handleAxiosErrors = (error) => {
    throw BaseError.fromJSON(error)
}
